import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsDELETE,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import removeCaracters from '../utils/removeCaracters';
import newFetch from '../utils/newFetch';

const state = {
  couriers: [],
  vehiclesTypes: [],
  summaryData: [],
  typeDocumentPhotos: [],
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    Name: null
  }
};

const getters = {
  getCouriers: (state) => state.couriers,
  getVehiclesTypes: (state) => state.vehiclesTypes,
  getTypeDocumentPhotos: (state) => state.typeDocumentPhotos,
  getSummaryData: (state) => state.summaryData,
  getPaginate: ({ paginate }) => {
    return `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}`;
  },
  getFilters: ({ filters }) => {
    return filters.Name ? '&Name' : '';
  }
};

const mutations = {
  setCouriers(state, payload) {
    state.couriers = payload;
  },
  setVehiclesTypes(state, payload) {
    state.vehiclesTypes = payload;
  },
  setSummaryData(state, payload) {
    state.summaryData = payload;
  },
  setTypeDocumentPhotos(state, payload) {
    state.typeDocumentPhotos = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  toggleDisableCourier(state, payload) {
    state.couriers[payload.index].disabled = !payload.disabled;
  },
  trashCourier(state, payload) {
    state.couriers = state.couriers.filter(({ id }) => id !== payload);
  },
  setNameFilter(state, payload) {
    state.filters.Name = payload;
  }
};

const actions = {
  fetchCouriers(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getCouriers + context.getters.getPaginate,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setCouriers', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchCouriersWithFilters(context, params) {
    const { pageSize, pageNumber } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getCouriers + `?PageSize=${pageSize}&PageNumber=${pageNumber}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setCouriers', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchSummaryData(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSummaryData, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setSummaryData', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchVehiclesTypes(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getVehiclesTypes, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setVehiclesTypes', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTypeDocumentPhotos(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getTypeDocumentPhotos, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setTypeDocumentPhotos', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createCouriers(context, body) {
    let newBody = {
      nickName: body.params.nickName,
      transhipmentId: body.params.transhipmentId,
      name: body.params.name,
      cpf: body.params.cpf,
      cnhNumber: removeCaracters(body.params.cnhNumber),
      email: body.params.email,
      password: body.params.password,
      confirmPassword: body.params.confirmPassword,
      phones: [removeCaracters(body.params.phoneNumber)],
      address: body.params.addressData,
      bankData: body.params.bankData,
      vehicle: body.params.vehicleData,
      documentPhotos: body.params.documentPhotos
    };

    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createCouriers, requestOptionsPOST(localStorage.getItem('accessToken'), newBody))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editCouriers(_, body) {
    let newBody = {
      id: body.params.id,
      nickName: body.params.nickName,
      name: body.params.name,
      cpf: body.params.cpf,
      cnhNumber: removeCaracters(body.params.cnhNumber),
      email: body.params.email,
      password: body.params.password,
      confirmPassword: body.params.confirmPassword,
      phones: [removeCaracters(body.params.phoneNumber)],
      address: body.params.addressData,
      bankData: body.params.bankData,
      vehicle: body.params.vehicleData,
      documentPhotos: body.params.documentPhotos
    };

    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createCouriers, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), newBody))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteCourier(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getCouriers + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  toggleCourier(_, item) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (!item.disabled ? Api.disableCouriers : Api.enableCouriers) + item.id,
        requestOptionsPUT(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchCourierByID(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createCouriers + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
